
import { computed, defineComponent } from 'vue';
import { AppDropdown } from '@/components';
import { useAppRouter } from '@/common/route/useAppRouter';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';
import { useAppStore } from '@/modules/apps/store';
import { storeToRefs } from 'pinia';
import { App } from '@/modules/apps/types';
import { useMaintenanceStore } from '@/modules/maintenance/store';

export default defineComponent({
    name: 'ApplicationsDropdown',
    components: { AppDropdown },
    setup() {
        const router = useAppRouter();
        const appStore = useAppStore();

        const { isMaintained } = storeToRefs(useMaintenanceStore());
        const { apps, appId, currentApp } = storeToRefs(appStore);

        const dropdownAppList = computed(() => [...apps.value, { id: null, name: 'All Application' }] as Array<App>);
        const getApplicationName = computed(() => currentApp.value?.name ?? '');

        async function changeApplication(newAppId: number) {
            if (newAppId) {
                appStore.setAppId(newAppId);
                const currentRoute = router.currentRoute.value;
                const newPath = router.resolve({
                    name: currentRoute.name,
                    query: { ...currentRoute.query },
                    params: { ...currentRoute.params, appId: newAppId }
                }).fullPath;

                window.location.href = newPath;
            } else {
                router.push({ name: ROUTE_NAME_APPLICATION.INDEX });
            }
        }

        return { dropdownAppList, appId, getApplicationName, isMaintained, changeApplication };
    }
});
